// extracted by mini-css-extract-plugin
export var cardHeader = "ApplicationCard-module--cardHeader--4aa85";
export var container = "ApplicationCard-module--container--af780";
export var description = "ApplicationCard-module--description--e916e";
export var tags = "ApplicationCard-module--tags--3a901";
export var titleLink = "ApplicationCard-module--titleLink--5e3d5";